export enum Animation {
  WHITE_LOGO = 'WHITE_LOGO',
  BLACK_LOGO = 'BLACK_LOGO',
}
